module.exports = __webpack_public_path__ + "img/app1.19c808f5.png";